import QueryService from '@/services/query'
import { VUE_APP_ROOT_API } from '@/helpers/env'

export default {
  getAllGatherings: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/mobileapi/rassemblementsall`)
    return await response.json()
  },
  getAllBusinesses: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/mobileapi/entrepreneursall`)
    return await response.json()
  }
}